import * as Linking from "expo-linking";
import { useCallback, useMemo, useState } from "react";
import { Circle, isWeb, LoadingButton, Paragraph, Spinner, Subheadline3, useFocusEffect, YStack } from "@medbillai/ui";
import { PushPermissionStatus, pushNotificationsService, useNotificationPermission } from "../../../../lib/push-notifications";
import { useScreenLock } from "../../../../lib/screen-lock";
export const InsuranceLinkingBlock = () => {
  const {
    disableScreenLock,
    enableScreenLock
  } = useScreenLock();
  const {
    permissionStatus,
    refetch: notificationRefetch
  } = useNotificationPermission();
  const [isPromptLoading, setIsPromptLoading] = useState(false);
  useFocusEffect(useCallback(() => {
    if (permissionStatus !== PushPermissionStatus.Granted) {
      void notificationRefetch();
    }
  }, [permissionStatus, notificationRefetch]));
  const requestNotificationPermission = useCallback(async () => {
    setIsPromptLoading(true);
    disableScreenLock();
    await pushNotificationsService.showPermissionStatusPrompt();
    await notificationRefetch();
    enableScreenLock();
    setIsPromptLoading(false);
  }, [disableScreenLock, enableScreenLock, notificationRefetch]);
  const handleSettingsRedirect = useCallback(async () => {
    setIsPromptLoading(true);
    await Linking.openSettings().catch(() => {
      console.error("Failed to open settings");
    });
    setIsPromptLoading(false);
  }, []);
  const getPermissionContent = useMemo(() => {
    switch (permissionStatus) {
      case PushPermissionStatus.Granted:
        return {
          description: "We'll notify you when we're done.",
          buttonText: null,
          buttonAction: null
        };
      case PushPermissionStatus.Denied:
        return {
          description: isWeb ? "Check back later to view your bills" : "If you would like to be notified, please \n enable notifications in your settings.",
          buttonText: isWeb ? null : "Go to Settings",
          buttonAction: isWeb ? null : handleSettingsRedirect
        };
      default:
        return {
          description: isWeb ? "Check back later to view your bills" : "Would you like to be notified when \n we're done?",
          buttonText: isWeb ? null : "Notify Me",
          buttonAction: isWeb ? null : requestNotificationPermission
        };
    }
  }, [handleSettingsRedirect, permissionStatus, requestNotificationPermission]);
  return <YStack alignItems="center" justifyContent="flex-start" gap="$2" $platform-web={{
    maxWidth: 400,
    mx: "$5"
  }} data-sentry-element="YStack" data-sentry-component="InsuranceLinkingBlock" data-sentry-source-file="InsuranceLinkingBlock.tsx">
      <YStack alignItems="center" data-sentry-element="YStack" data-sentry-source-file="InsuranceLinkingBlock.tsx">
        <Circle size="$8" backgroundColor="$backgroundTertiary" zIndex={2} justifyContent="center" alignItems="center" data-sentry-element="Circle" data-sentry-source-file="InsuranceLinkingBlock.tsx">
          <Spinner
        // The spinner isnt centered when using the large variant this
        // padding compensates for it.
        size="large" color="$iconDefault" pt={5} pl={2} data-sentry-element="Spinner" data-sentry-source-file="InsuranceLinkingBlock.tsx" />
        </Circle>
      </YStack>
      <Subheadline3 numberOfLines={2} pt="$2" textAlign="center" data-sentry-element="Subheadline3" data-sentry-source-file="InsuranceLinkingBlock.tsx">
        {"We're working on \n importing your bills"}
      </Subheadline3>
      <Paragraph theme="alt1" px="$8" textAlign="center" data-sentry-element="Paragraph" data-sentry-source-file="InsuranceLinkingBlock.tsx">
        {getPermissionContent.description}
      </Paragraph>
      <YStack mt="$4" height="$5" minHeight="$5" justifyContent="center" alignItems="center" data-sentry-element="YStack" data-sentry-source-file="InsuranceLinkingBlock.tsx">
        {getPermissionContent.buttonAction ? <LoadingButton onPress={getPermissionContent.buttonAction} loading={!!(isPromptLoading && permissionStatus === PushPermissionStatus.NotDetermined)} width="$12" height="$4">
            {getPermissionContent.buttonText}
          </LoadingButton> : null}
      </YStack>
    </YStack>;
};